export default __webpack_public_path__ + "static/media/cert-startup-consumer.c253a062.jpg";